/**
 * @name v0.1.1版本过渡
 * @params { Object } formData 表单数据
 * @returns { Object } 过渡之后的数据
 * @author liuguisheng
 * @version 2020-4-21
 * 
*/
// 导入v0.1.1数据格式
import * as v010 from './v010.js';

export const upgrade = function ( formData ) {
    // 取出当前版本
    let { version } = formData;
    if ( version == '0.1.1') return formData;
    let currentData = v010.upgrade(formData);
    let { formMap } = currentData;
    let includeColorRender = ['input','textarea', 'radio','checkbox','select'];
    // 添加配置
    for ( let key in formMap) {
        let { type } = formMap[key].node;
        if (includeColorRender.includes(type)) {
            formMap[key].renderOption.isUnderline = true;
        }
    }
    // 版本号更新
    currentData.version = '0.1.1';
    return currentData;
}


// WEBPACK FOOTER //
// ./src/assets/version/v011.js